import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AttributeType } from './types';
import Checkbox from './elements/Checkbox';
import Color from './elements/Color';
import Radio from './elements/Radio';
import Select from './elements/Select';
import { useVariantsStore } from '../../store/variants';
export function Variants() {
    const attributes = useVariantsStore((state) => state.attributes);
    return (_jsx("div", { className: "variants d-flex flex-column product__detail-variants", children: attributes.map((attribute, i) => {
            if (!Object.values(AttributeType).includes(attribute.type)) {
                console.log(`Unknown attribute type: ${attribute.type} with id: ${attribute.id}`);
                return null;
            }
            return (_jsxs("div", { className: `d-flex flex-column ${i > 0 && 'mt-2'}`, children: [_jsx("span", { className: "attribute-text", children: _jsx("strong", { children: attribute.name }) }), attribute.type === AttributeType.COLOR && _jsx(Color, { attribute: attribute }, `attribute-${i}`), attribute.type === AttributeType.RADIO && _jsx(Radio, { attribute: attribute }, `attribute-${i}`), attribute.type === AttributeType.SELECT && _jsx(Select, { attribute: attribute }, `attribute-${i}`), attribute.type === AttributeType.CHECKBOX && _jsx(Checkbox, { attribute: attribute }, `attribute-${i}`)] }, `attributes-${i}`));
        }) }));
}
